import { Paper, Table, TableContainer } from "@mui/material";
import React from "react";

const CustomTable = ({ children, height, noBorder, isOverflowVisible = true, calcHeight }) => {


  return (
    <TableContainer component={Paper} style={{ height: `calc(100vh - ${calcHeight ? calcHeight : 165}px)`, overflowY: "auto" }} className="scrollbar-primary">
      <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
        {children}
      </Table>
    </TableContainer>
  )

  //   return (
  //     <div
  //       className={`flex h-full flex-col ${isOverflowVisible && "overflow-hidden"} rounded-sm ${
  //         noBorder ? "" : "border dark:border-customGray-100 border-gray-300"
  //       } `}
  //       style={{ height }}
  //     >
  //       <div className={`flex-grow ${isOverflowVisible && "overflow-auto scrollbar scrollbar-primary"} `}>
  //         {children}
  //       </div>
  //     </div>
  //   );
};

export default CustomTable;
